namespace SP {


    export class SortableList {
        container = document.createElement("ul");
        _moveItem: SortableListElement;
        _itemStartY: number;
        _startY: number;
        _items: SortableListElement[] = [];
        _itemsDictionary: { [key: string]: SortableListElement } = {};
        _moveEv: (e: any) => any;
        _touchMoveEv: (e: any) => any;
        _mouseUp: (e: any) => any;
        _itemHeight = 56;
        _itemMargin = 4;
        onChange: () => void = null;
        constructor(parent: HTMLElement) {
            this.container.classList.add("sortable_list", "noselect");
            this._moveEv = (e: PointerEvent) => { this.onMove(e); e.preventDefault(); return false; };
            this._touchMoveEv = (e: TouchEvent) => { e.preventDefault(); return false; };
            this._mouseUp = (e: PointerEvent) => { this.endMove(); e.preventDefault(); return false; };
            parent.appendChild(this.container);
        }

        set value(data: string[]) {
            for (let i = 0; i < data.length; i++) {
                var item = this._itemsDictionary[data[i]];
                this._items.splice(item.index, 1);
                this._items.splice(i, 0, item);
                this.organize();
            }
        }

        get value() {
            return this._items.map(item => item.value);
        }

        get intValue() {
            return this._items.map(item => parseFloat(item.value));
        }

        AddItem(item: SortableListElement) {
            this._items.push(item);
            this._itemsDictionary[item.value] = item;
            this.container.appendChild(item.container);
            this.organize();

            let click = (ev: any) => {
                let e = ev.touches ? ev.touches[0] : ev;

                this._startY = e.clientY;
                this.startMove(item);
                ev.preventDefault();
                return false;
            };

            item.handle.addEventListener("mousedown", (e: MouseEvent) => { click(e); });
            item.handle.addEventListener("touchstart", click);
        }

        onMove(ev: any) {
            let e = ev.touches ? ev.touches[0] : ev;
            var offset = e.clientY - this._startY;
            var newTop = this._itemStartY + offset;
            this._moveItem.container.style.top = newTop + "px";
            var newIndex = Math.min(this._items.length - 1, Math.max(0, Math.round(newTop / (this._itemHeight + this._itemMargin))));
            if (newIndex != this._moveItem.index) {
                this._items.splice(this._moveItem.index, 1);
                this._items.splice(newIndex, 0, this._moveItem);
                this.organize();
            }
        }

        organize() {
            let total_height = 0;//this._itemMargin;

            for (let i = 0; i < this._items.length; i++) {
                let item = this._items[i];
                item.index = i;
                total_height += this._itemHeight + this._itemMargin;
                if (item != this._moveItem) item.container.style.top = ((this._itemHeight + this._itemMargin) * i) + "px";
            }

            console.log("total height:", total_height);
            this.container.style.height = total_height + "px";
        }

        startMove(item: SortableListElement) {
            if (this._moveItem == null) {
                console.log("start");
                document.addEventListener("mouseup", this._mouseUp);
                document.addEventListener("touchend", this._mouseUp);
                document.addEventListener("touchmove", this._moveEv);
                document.addEventListener("mousemove", this._moveEv);
                this._moveItem = item;
                this._moveItem.container.style.transition = "none";
                this._moveItem.container.style.zIndex = "100";
                this._itemStartY = parseFloat(this._moveItem.container.style.top.replace("px", ""));
            }
        }

        endMove() {
            if (this._moveItem != null) {
                console.log("stop");
                document.removeEventListener("mouseup", this._mouseUp);
                document.removeEventListener("touchend", this._mouseUp);
                document.removeEventListener("touchmove", this._moveEv);
                document.removeEventListener("mousemove", this._moveEv);
                this._moveItem.container.style.transition = "all ease-out 0.1s";
                this._moveItem.container.style.zIndex = "";
                this._moveItem = null;
                this.organize();
                if (this.onChange != null)
                    this.onChange();
            }
        }
    }

    export class SortableListElement {
        container = document.createElement("li");
        handle = document.createElement("div");
        value: string;

        private _value: string[];
        index: number;

        constructor(text: string, value: string) {
            this.value = value;
            this.container.innerHTML = text;
            this.container.prepend(this.handle);
            this.handle.innerHTML = '<img src="/terminal/img/drag.svg" />';
        }
    }
}